module.exports = __webpack_public_path__ + "static/media/paragon_3.875338c2.jpg";